module.exports = __webpack_public_path__ + "static/media/triple-chocolate-deluxe.c383d4ce.png";